<template>
  <v-container>
    <v-row>
      <div class="select">{{ nomOperari }}</div>
    </v-row>
    <v-row align="center">
      <v-chip v-if="error == false" class="mr-2">{{ estat }}</v-chip>
      <v-chip v-else color="red" class="mr-2">{{ estat }}</v-chip>
      <v-btn
        v-if="ordre && principal"
        @click="entrarMaterial()"
        rounded
        color="blue"
        style="color: white"
        >{{ $t("EntrarMaterial") }}</v-btn
      >
    </v-row>

    <v-row justify="center">
      <span class="clock">{{ time }}</span>
    </v-row>

    <v-row xs12 v-if="mode != 'N'">
      <v-select
        class="select"
        v-model="tipusFitxada"
        :items="tipus"
        item-value="id"
        item-text="nom"
        return-object
        @change="onChangeTipus($event)"
      ></v-select>
    </v-row>

    <v-row>
      <v-btn height="90px" block large @click="iniciar()" color="green">
        {{ $t("Iniciar") }}
        <v-icon right dark>mdi-arrow-right-thick</v-icon>
      </v-btn>
    </v-row>
    <v-row class="mt-6">
      <v-btn
        height="90px"
        block
        large
        @click="finalitzar()"
        color="red"
        :disabled="desactivarFi"
      >
        {{ $t("Finalitzar") }}
        <v-icon right dark>mdi-arrow-left-thick</v-icon>
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import api from "../api.js";
import Cookies from "js-cookie";

export default {
  created() {
    axios.get(api.URL() + "/api/v1/mode").then((response) => {
      this.mode = response.data;
      sessionStorage.setItem("systimes.mode", this.mode);
    });
    axios
      .post(api.URL() + "/api/v1/token", { token: Cookies.get("st3token") })
      .then((response) => {
        if (response.data != "OK") this.$router.push("/Token");
      });
    this.loadData();
    this.tipusFitxada = 0;
    this.desactivarFi = false;
    if (Cookies.get("idioma") == "Català") {
      this.$i18n.locale = "ca";
    } else {
      this.$i18n.locale = "es";
    }
  },
  mounted() {
    this.ordre = sessionStorage.getItem("systimes.ordre");
    if (this.ordre != null) {
      this.ordre = JSON.parse(this.ordre);
      this.principal = this.ordre?.principal == "S";
    }
    
    if (sessionStorage.getItem("systimes.inici") == "1") {
      sessionStorage.setItem("systimes.inici", "0");
      this.iniciar();
    }
  },
  data: () => ({
    error: false,
    version: Cookies.get("version"),
    nomOperari: Cookies.get("nomOperari"),
    tipusFitxada: 0,
    estat: sessionStorage.getItem("systimes.estat"),
    time: "--:--",
    seconds: "",
    tipus: [],
    ultMilis: new Date().getTime(),
    desactivarFi: false,
    mode: "",
    ordre: null,
    principal: false,
  }),
  methods: {
    entrarMaterial() {
      var or = sessionStorage.getItem("systimes.ordre");
      if (or != null && or != "") {
        this.$store.commit("setBack", "/");
        if (sessionStorage.getItem("systimes.mode") == "N") {
          this.$router.push("Material");
        } else {
          this.$router.push("MaterialG");
        }
      }
    },
    eventEntrada(lat, lng, ordre) {
      console.log("Entrada...");
      this.error = false;
      axios
        .post(api.URL() + "/api/v1/event", {
          id: Number(Cookies.get("idOperari")),
          tipus: "I",
          tipusFitxada: this.tipusFitxada.id,
          lat: lat,
          lng: lng,
          ordre: ordre,
        })
        .then(() => {
          if (this.tipusFitxada == 0) {
            this.estat = "Entrada " + this.time;
          } else {
            console.log(this.tipusFitxada);
            this.estat = this.tipusFitxada.nom + " " + this.time;
            this.tipusFitxada = 0;
            this.desactivarFi = false;
          }

          sessionStorage.setItem("systimes.estat", this.estat);
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
          this.tipusFitxada = 0;
          this.desactivarFi = false;
          if (err.response.status == 401) {
            if (Cookies.get("idioma") == "Català") {
              this.estat = "Usuari no autoritzat";
            } else {
              this.estat = "Usuario no autorizado";
            }
          } else if (err.response.status == 409) {
            if (Cookies.get("idioma") == "Català") {
              this.estat =
                "Presència ignorada per marge de temps amb una altra presència a les " +
                err.response.data;
            } else {
              this.estat =
                "Presencia ignorada por margen de tiempo con otra presencia a las" +
                err.response.data;
            }
          } else {
            if (Cookies.get("idioma") == "Català") {
              this.estat = "Error connectant amb el servidor";
            } else {
              this.estat = "Error conectando con el servidor";
            }
          }
        });
    },
    eventSortida(lat, lng, ordre) {
      console.log("Sortida...");
      this.error = false;
      axios
        .post(api.URL() + "/api/v1/event", {
          id: Number(Cookies.get("idOperari")),
          tipus: "F",
          tipusFitxada: this.tipusFitxada.id,
          lat: lat,
          lng: lng,
          ordre: ordre,
        })
        .then(() => {
          if (Cookies.get("idioma") == "Català") {
            this.estat = "Sortida " + this.time;
          } else {
            this.estat = "Salida " + this.time;
          }

          sessionStorage.setItem("systimes.estat", this.estat);
          this.tipusFitxada = 0;
          this.desactivarFi = false;
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
          this.tipusFitxada = 0;
          this.desactivarFi = false;
          if (err.response.status == 401) {
            if (Cookies.get("idioma") == "Català") {
              this.estat = "Usuari no autoritzat";
            } else {
              this.estat = "Usuario no autorizado";
            }
          } else if (err.response.status == 409) {
            if (Cookies.get("idioma") == "Català") {
              this.estat =
                "Presència ignorada per marge de temps amb una altra presència a les " +
                err.response.data;
            } else {
              this.estat =
                "Presencia ignorada por margen de tiempo con otra presencia a las " +
                err.response.data;
            }
          } else {
            if (Cookies.get("idioma") == "Català") {
              this.estat = "Error connectant amb el servidor";
            } else {
              this.estat = "Error conectando con el servidor";
            }
          }
        });
    },
    iniciar() {
      if (sessionStorage.getItem("systimes.mode") == "C") {
        this.iniciar1();
      } else {
        axios
          .post(api.URL() + "/api/v1/operari", {
            id: Number(Cookies.get("idOperari")),
          })
          .then((resp) => {
            if (resp.data.ordres == "S") {
              // TODO
              axios
                .post(api.URL() + "/api/v1/hiHaOrdresPendents", {
                  id: Number(Cookies.get("idOperari")),
                })
                .then((response) => {
                  if (sessionStorage.getItem("systimes.mode") == "N") {
                    if (response.data > 0) {
                      sessionStorage.setItem("systimes.inici", "1");
                      this.$router.push("/OrdresPendents");
                    } else {
                      this.$router.push("/Ordres");
                    }
                  } else {
                    if (response.data > 0) {
                      sessionStorage.setItem("systimes.inici", "1");
                      this.$router.push("/OrdresPendentsG");
                    } else {
                      sessionStorage.setItem(
                        "systimes.tipusFixada",
                        this.tipusFitxada.toString()
                      );
                      this.$router.push("/OrdresG");
                    }
                  }
                });
            } else {
              this.iniciar1();
            }
          })
          .catch(() => {
            this.iniciar1();
          });
      }
    },
    iniciar1() {
      var milis = new Date().getTime();
      console.log(milis, this.ultMilis);
      if (milis - this.ultMilis > 1000) {
        /*
        this.$getLocation()
          .then((coordinates) => {
            this.eventEntrada(coordinates.lat, coordinates.lng);
            console.log(coordinates);
          })
          .catch(() => {
            this.eventEntrada(0, 0, "");
          });
        */
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              this.eventEntrada(
                position.coords.latitude,
                position.coords.longitude
              );
              console.log(position);
            },
            (error) => {
              console.log(error);
              this.eventEntrada(0, 0, "");
            }
          );
        } else {
          this.eventEntrada(0, 0, "");
        }
      }
      this.ultMilis = new Date().getTime();
    },

    finalitzar() {
      if (sessionStorage.getItem("systimes.mode") == "C") {
        this.finalitzar1();
      } else {
        axios
          .post(api.URL() + "/api/v1/operari", {
            id: Number(Cookies.get("idOperari")),
          })
          .then((resp) => {
            if (resp.data.ordres == "S") {
              /*
              this.$getLocation();
                .then((coordinates) => {
                  this.finalitzar0(coordinates.lat, coordinates.lng);
                })
                .catch(() => {
                  this.finalitzar0(0.0, 0.0);
                });
              */
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                  (position) => {
                    this.finalitzar0(
                      position.coords.latitude,
                      position.coords.longitude
                    );
                    console.log(position);
                  },
                  (error) => {
                    console.log(error);
                    this.finalitzar0(0.0, 0.0);
                  }
                );
              } else {
                this.finalitzar0(0.0, 0.0);
              }
            } else {
              this.finalitzar1();
            }
          })
          .catch((error) => {
            console.log(error);
            this.finalitzar1();
          });
      }
    },
    finalitzar0(lat, lng) {
      sessionStorage.setItem("systimes.lat", lat);
      sessionStorage.setItem("systimes.lng", lng);
      if (sessionStorage.getItem("systimes.mode") == "N") {
        this.$router.push("/OrdresPendents");
      } else {
        this.$router.push("/OrdresPendentsG");
      }
      /*
      axios
        .post(api.URL() + "/api/v1/sortidaOrdre", {
          idOperari: Number(Cookies.get("idOperari")),
          nomOperari: Cookies.get("nomOperari"),
          lat: lat,
          lng: lng,
        })
        .then(() => {
          this.estat = "Sortida " + this.time;
          sessionStorage.setItem("systimes.estat", this.estat);
        })
        .catch(() => {});
        */
    },
    finalitzar1() {
      var milis = new Date().getTime();
      if (milis - this.ultMilis > 1000) {
        /*
        this.$getLocation()
          .then((coordinates) => {
            this.eventSortida(coordinates.lat, coordinates.lng);
            console.log(coordinates);
          })
          .catch(() => {
            this.eventSortida(0, 0, "");
          });
        */
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              this.eventSortida(
                position.coords.latitude,
                position.coords.longitude,
                ""
              );
              console.log(position);
            },
            (error) => {
              console.log(error);
              this.eventSortida(0, 0, "");
            }
          );
        } else {
          this.eventSortida(0, 0, "");
        }
      }
      this.ultMilis = new Date().getTime();
    },
    getTime() {
      axios.get(api.URL() + "/api/v1/time").then((response) => {
        this.time = response.data;
        sessionStorage.setItem("systimes.time", this.time);
      });
    },
    clock() {
      var d = new Date();
      this.time =
        d.getHours().toString().padStart(2, "0") +
        ":" +
        d.getMinutes().toString().padStart(2, "0");
      this.seconds = d.getSeconds().toString().padStart(2, "0");
      sessionStorage.setItem("systimes.time", this.time);
    },
    loadData() {
      axios.get(api.URL() + "/api/v1/tipus").then((response) => {
        this.tipus = response.data;
      });
    },
    onChangeTipus(event) {
      this.desactivarFi = !(event.id == 0);
    },
  },

  timers: {
    clock: {
      time: 1000,
      repeat: true,
      inmediate: true,
      autostart: true,
    },
    loadData: {
      time: 60000,
      repeat: true,
      inmediate: true,
      autostart: true,
    },
  },
};
</script>

<style>
.clock {
  font-size: 100px;
  font-weight: bold;
}

.select {
  font-size: 20px;
  font-weight: bold;
}

.version {
  font-size: 10px;
  font-weight: bold;
}
</style>


